import { defineMessages } from 'react-intl';

export default defineMessages({
    whenIsTheBestTime: {
        id: 'fnol.adac.callback-options-page.When is the best time for us to reach you?',
        defaultMessage: 'When is the best time for us to reach you?'
    },
    callback1: {
        id: 'fnol.adac.callback-options-page.1 hour',
        defaultMessage: '1 hour'
    },
    callback2: {
        id: 'fnol.adac.callback-options-page.2 hours',
        defaultMessage: '2 hours'
    },
    callback3: {
        id: 'fnol.adac.callback-options-page.3 hours',
        defaultMessage: '3 hours'
    },
    weCallYou: {
        id: 'fnol.adac.callback-options-page.We will call you within:',
        defaultMessage: 'We will call you within:'
    },
    costsOnProvider: {
        id: 'fnol.adac.callback-options-page.Connection costs depending on network operator/provider',
        defaultMessage: 'Connection costs depending on network operator/provider'
    },
    acceptPrivacy: {
        id: 'fnol.adac.confirmation-page.Akccept privacy policy',
        defaultMessage: 'I agree that communication with ADAC will be in electronic form via Portal',
    },
});
